export default __webpack_public_path__ + "static/media/logo3.fb7a3328.svg";